import { Chip, Input, InputProps } from "@heroui/react"
import { Box } from "@mui/material"
import { useEffect, useMemo, useState } from "react"
import Card from "../../../components/Card"
import { Column, Row, ScrollableList } from "../../../components/Layout"
import TextLabel from "../../../components/typography/TextLabel"
import TextSkeleton from "../../../components/typography/TextSkeleton"
import TextWithRegion from "../../../components/typography/TextWithRegion"
import useCompaniesAPI from "../../../hooks/useCompaniesAPI"
import { Company } from "../../../types"
import useJobsPageStore from "../hooks/useJobsPageStore"
import AdvertsCounters from "./AdvertsCounters"
import useJobsCountAPI from "../../../hooks/useJobsCountAPI"

const dummyOption: Company = { jobScannerKey: "", name: "", new: false }
const dummyOptions: Company[] = []
const dummyOptionsLength = 8

for (var i = 0; i < dummyOptionsLength; i++) {
    dummyOptions.push(dummyOption)
}

export default function CompanyList() {

    const { loading: companyDataLoading, companies: companyData } = useCompaniesAPI()
    const { setSelectedKey, selectedKey: selectedJobScannerKey, selectedRegion, selectedRegionDetails, setSelectedCompanyName } = useJobsPageStore()

    const [companies, setCompanies] = useState<Company[]>([])

    const [filterCompanyName, setFilterCompanyName] = useState<string>("");
    const resetCompanyNameFilter = () => setFilterCompanyName("");

    const { loading: countersLoading, counters: allCounters, fetchJobsCount } = useJobsCountAPI()

    useEffect(() => {
        fetchJobsCount(selectedRegion)
    }, [selectedRegion])


    useEffect(() => {

        if (selectedJobScannerKey == null && companies.length > 0) {
            setSelectedKey(companies[0].jobScannerKey)
            setSelectedCompanyName(companies[0].name)
        }

    }, [selectedJobScannerKey, companies])


    useEffect(() => {

        if (!companyDataLoading && companyData != null) {
            setCompanies(companyData)
        }

    }, [selectedJobScannerKey, selectedRegion, companyDataLoading, companyData])


    function filterCompanies() {
        // console.log("---------------------------------------")
        // console.log("Filtering company list...", companyData)

        var _options: Company[] = []

        if (companyDataLoading) {
            _options = dummyOptions;
        } else {
            if (filterCompanyName) {
                _options = companies.filter(c => {
                    const _c = c.name.toLowerCase()
                    const _query = filterCompanyName.toLowerCase()
                    const _contains = _c.includes(_query)
                    const _alphanumericContains = _c.replace(/[^a-zA-Z0-9]/g, '').includes(_query)
                    return _contains || _alphanumericContains
                })
            } else {
                _options = companies
            }
        }

        // console.log("Company list updated...", _options)

        return _options
    }

    // const options: Company[] = useMemo(filterCompanies, [
    //     companyData,
    //     companyDataLoading,
    //     filterCompanyName,
    //     selectedJobScannerKey,
    //     selectedRegion
    // ])

    // const options = filterCompanies().sort((a, b) => { return a.new && !b.new ? 0 : 1 })
    const options = filterCompanies().sort((a, b) => {
        // New items first
        if (a.new && !b.new) return -1;
        if (!a.new && b.new) return 1;

        // Then alphabetical
        return a.name.localeCompare(b.name);
    });

    const filtersApplied = Boolean(filterCompanyName)

    const props: InputProps = {}

    const regionHasShortName = Boolean(selectedRegionDetails?.regionShortName)

    return (
        <Card className="custom-company-select h-full" fullWidth>
            <Column className="max-h-[80vh]" fullWidth>
                <Box px={1} width={'100%'}>
                    <Row justifyContent={"space-between"} mb={1}>
                        <TextLabel>Companies</TextLabel>
                        <TextLabel>{filtersApplied ? "Found:" : "Total:"} {companyDataLoading ? '-' : options.length}</TextLabel>
                    </Row>
                    <Row>
                        <Input
                            {...props}

                            size="sm"
                            labelPlacement="outside"
                            label="Search"
                            placeholder="Search companies..."
                            variant="bordered"
                            isClearable
                            onChange={(e) => setFilterCompanyName(e.target.value)}
                            onClear={resetCompanyNameFilter}
                        />
                    </Row>
                </Box>


                <ScrollableList maxHeight="75vh" px={1} gap={2.25}
                    fullWidth

                    items={
                        options.map(
                            function (company, i) {

                                const counters = allCounters != null ? allCounters[company.jobScannerKey] : null;
                                var countersWidget;
                                const isNew = company.new;

                                if (counters != null) {
                                    const { total, new: newCount, closed } = counters

                                    if (total == 0 && newCount == 0 && closed == 0) {
                                        countersWidget = (
                                            <Box sx={{ mx: "auto", textAlign: "center" }}>
                                                <TextLabel>{regionHasShortName ? `No jobs found in ${selectedRegionDetails?.regionName}.` : "No jobs found."}</TextLabel>
                                            </Box>
                                        )
                                    } else {
                                        countersWidget = (<AdvertsCounters loading={countersLoading} new={newCount} closed={closed} total={total} compact />)
                                    }

                                } else {
                                    countersWidget = (<AdvertsCounters loading={false} new={null} closed={null} total={null} compact />)
                                }

                                return <Card
                                    className={`custom-company-select-option ${selectedJobScannerKey == company.jobScannerKey ? "company-selected" : ""}`}
                                    isPressable
                                    isHoverable
                                    scaleOnHover={!companyDataLoading}
                                    key={`${i}_${company.jobScannerKey}`}
                                    fullWidth
                                    onPress={() => {
                                        if (!companyDataLoading) {
                                            // console.log(o.jobScannerKey)
                                            setSelectedKey(company.jobScannerKey)
                                            setSelectedCompanyName(company.name)
                                        }
                                    }}
                                >

                                    <Row style={{ justifyContent: "space-between", textAlign: "left" }}>
                                        {companyDataLoading ? <TextSkeleton /> : <TextWithRegion text={company.name} useLabel showCountryIcon isNew={isNew} />}


                                        <Column width={"43%"}>{countersWidget}</Column>
                                    </Row>
                                </Card>

                            }
                        )
                    }>
                </ScrollableList>
            </Column>
        </Card>
    )

}